import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '@/config/firebase';
import type { VacationOverviewDocument } from '../models/vacationOverview.types';

export class VacationOverviewService {
	static async getAllOverviews(): Promise<VacationOverviewDocument[]> {
		const overviewCollection = collection(db, 'vacationOverview');
		const q = query(overviewCollection, where('inBase', '==', true));
		const overviewSnapshot = await getDocs(q);

		return overviewSnapshot.docs.map(d => ({
			collaboratorId: d.id,
			...d.data(),
		} as VacationOverviewDocument));
	}
}
